module.exports = __webpack_public_path__ + "static/media/motoraceite.e9aff26a.jpg";